import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
const RadioGroup = ({ name, register, value, error, info, options }) => {
  const radioOptions = options.map((option, index) => (
    <div key={option.value} className="form-check">
      <input
        className={classnames("form-check-input ", {
          "is-invalid": error
        })}
        type="radio"
        name={name}
        ref={register}
        id={option.value}
        value={option.value}
      />

      {option.label}
    </div>
  ));

  return (
    <div className="form-group">
      {radioOptions}

      {info && <small className="form-text text-muted">{info}</small>}
      {error && <div className="invalid-feedback d-block">{error.message}</div>}
    </div>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  info: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.array.isRequired
};

export default RadioGroup;
